// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const app = angular.module('CustomerSupport');
app.directive('assistingTypeOptions', [
  () => ({
    restrict: 'E',
    replace: true,
    templateUrl: 'customer_support/_assisting_types.html',

    scope: {
      assistingTypeChanged: '=',
      assistingTypes: '=',
      memberUpdates: '=',
      indirectCountry: '=',
    },

    link(scope) {
      scope.QUESTION = 'q';
      scope.PROBLEM = 'p';
      scope.FEEDBACK = 'f';
      scope.SECURITY = 's';
      scope.ACCOUNT_UPDATE_QUESTION_ID = 6;

      // Options flagged hide_for_indirect_countries have no email recipient in
      // master-delegate (indirect) countries, where a submission would silently
      // drop. Hide them whenever the selected country is indirect.
      scope.visibleOption = (item) =>
        !(item.hideForIndirectCountries && scope.indirectCountry);

      scope.optionChanged = function (assistingType) {
        scope.assistingType = assistingType;
        switch (scope.assistingType) {
          case scope.QUESTION:
            return scope.validateOption({
              type: scope.assistingType,
              data: scope.questionSelected,
            });
          case scope.PROBLEM:
            return scope.validateOption({
              type: scope.assistingType,
              data: scope.problemSelected,
            });
          case scope.FEEDBACK:
            return scope.validateOption({
              type: scope.assistingType,
              data: scope.feedbackSelected,
            });
          case scope.SECURITY:
            return scope.validateOption({
              type: scope.assistingType,
              data: scope.securitySelected,
            });
        }
      };

      scope.validateOption = function (option) {
        option.valid =
          option.data !== undefined &&
          option.data !== null &&
          (option.data != null ? option.data.type : undefined) !== '';
        return scope.assistingTypeChanged(option);
      };

      scope.findById = (id) =>
        scope.assistingTypes.find((item) => item.id === id);

      scope.$on('form-sent', () => scope.initInterface());

      scope.initInterface = function () {
        scope.assistingType = scope.QUESTION;
        scope.assistingTypeChanged({ type: scope.QUESTION, valid: false });
        if (scope.memberUpdates) {
          scope.questionSelected = scope.findById(
            scope.ACCOUNT_UPDATE_QUESTION_ID
          );
          return scope.optionChanged(scope.QUESTION);
        }
      };

      // If the selected country changes to one where a chosen option is now
      // hidden, clear that selection so a hidden option can't be submitted,
      // then re-validate the active section.
      scope.$watch('indirectCountry', function () {
        const cleared = [
          'questionSelected',
          'problemSelected',
          'feedbackSelected',
          'securitySelected',
        ].filter((model) => scope[model] && !scope.visibleOption(scope[model]));
        if (cleared.length === 0) {
          return;
        }
        cleared.forEach((model) => {
          scope[model] = undefined;
        });
        if (scope.assistingType) {
          scope.optionChanged(scope.assistingType);
        }
      });

      scope.init = () => scope.initInterface();

      return scope.init();
    },
  }),
]);
